var _style, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkolenieIkonaOrangeyellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F6961D;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 48.3,
    cy: 54.5,
    r: 26.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.4,48.1l-14.2-7.3c-1.8-0.9-4-0.9-5.8,0l-14.2,7.3c-0.3,0.2-0.5,0.4-0.6,0.7c-0.3,0.7,0.1,1.5,0.8,1.7 l4.9,1.8v8l0.1,0.1c3.1,3.4,7.5,5.3,12.2,5.3c4.6,0,9-1.9,12.2-5.3l0.1-0.1v-7.6l0.2,0.1c0.3,0.1,0.6,0.5,0.6,0.8v11.6 c-0.2,0.1-0.3,0.4-0.3,0.6v2.2c0,0.4,0.4,0.8,0.8,0.8h0c0.4,0,0.8-0.4,0.8-0.8V66c0-0.2-0.1-0.5-0.3-0.6V53.7c0-0.8-0.5-1.5-1.2-1.7 l3.9-1.5c0.3-0.1,0.6-0.3,0.7-0.6C66.3,49.2,66.1,48.4,65.4,48.1z M59.8,60c-0.1,0.2-0.3,0.3-0.4,0.4c-6.2,6-16.1,5.8-22.1-0.4 l0-7.1l7.6,2.7l1.3,0.5c0.2,0.1,0.4,0.1,0.6,0.2l1.8,0.6l11.3-4V60z M64.9,49.6L60,51.4l-6.3-2.5c0,0,0,0,0,0 c-0.3-0.1-0.5,0-0.6,0.3c-0.1,0.3,0,0.5,0.3,0.6l5.3,2.1l-8.4,3.2c-1,0.4-2.1,0.4-3.2,0.2l-2-0.7l-13.3-5c-0.1,0-0.1-0.1-0.2-0.2 c-0.1-0.2,0-0.4,0.1-0.5l14.2-7.3c0.8-0.4,1.6-0.6,2.5-0.6c0.9,0,1.7,0.2,2.5,0.6L65,49c0.1,0,0.1,0.1,0.2,0.2 C65.2,49.3,65.1,49.5,64.9,49.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkolenieIkonaOrangeyellow);
export default __webpack_public_path__ + "static/media/skolenie_ikona_orangeyellow.231408c48dc2c686db2995219407b5f9.svg";
export { ForwardRef as ReactComponent };